import { useEffect } from "react";
import { carriersApi } from "@/App/Auth/carrierApi";

/**
 * Tells the backend which section this browser opened.
 *
 * The portal's credential is a permanent link shared around a carrier's team
 * with a self-asserted name, so nothing else records what any of them actually
 * came for. "Who signs in" we already had; "what they came to look at" is the
 * more useful half, and it's the one that says whether a section is worth
 * keeping.
 *
 * Deliberately fire-and-forget, and deliberately silent on failure: this is our
 * bookkeeping, and a carrier's navigation must never wait on it or break
 * because of it. The backend collapses repeats, so this can fire freely on
 * every section change.
 */
export function useRecordPageView(section: string | undefined): void {
  useEffect(() => {
    if (section === undefined) return;
    carriersApi()
      .recordCarrierPageView({ pageViewRequest: { section } })
      .catch(() => {
        // Nothing to tell the carrier — they didn't ask for this.
      });
  }, [section]);
}
